import { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAxios } from '../../utils/hook/useAxios';

function AdminUserItem({ data }) {
  const [PermisConduire, setPermisConduire] = useState(data?.PermisConduire);
  const [PieceIdentite, setPieceIdentite] = useState(data?.PieceIdentite);

  const [PermisConduireDoc, setPermisConduireDoc] = useState(data?.PermisConduireDoc);
  const [PieceIdentiteDoc, setPieceIdentiteDoc] = useState(data?.PieceIdentityDoc);
  const [ImmatriculationDoc, setImmatriculationDoc] = useState(data?.ImmatriculationDoc);

  const [activeDoc, setActiveDoc] = useState(null);
  const [activeDocTitle, setActiveDocTitle] = useState('');
  const axios = useAxios();

  useEffect(() => {
    setPermisConduire(data?.PermisConduire);
    setPieceIdentite(data?.PieceIdentite);
    setPermisConduireDoc(data?.PermisConduireDoc);
    setPieceIdentiteDoc(data?.PieceIdentityDoc);
    setImmatriculationDoc(data?.ImmatriculationDoc);
  }, [data]);

  const userId = data?.id;

  useEffect(() => {
    if (!userId) return;

    const saveChecks = async () => {
      try {
        await axios.put(`/users/${userId}`, {
          PermisConduire: PermisConduire == 1 ? 1 : 0,
          PieceIdentite: PieceIdentite == 1 ? 1 : 0,
        });
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };

    saveChecks();
  }, [userId, PermisConduire, PieceIdentite]);
  function handleApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(`/users/` + data?.id, {
          verified: '1',
        });
        if (responseOption.data) {
          toast.success("L'utilisateur a été bien approuvé. Elle est maintenant en ligne");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  function handleAskDocument() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.post(`/ask-documents-invite`, data);
        if (responseOption.data) {
          toast.success('Email envoyé avec succès');
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  function handledesApprouver() {
    let Approuve = async () => {
      try {
        const responseOption = await axios.put(`/users/` + data?.id, {
          verified: '0',
        });
        if (responseOption.data) {
          toast.success("L'utilisateur a été bien desapprouvé.");
        }
      } catch (error) {
        console.error('Erreur lors de la requête Axios :', error);
      }
    };
    Approuve();
  }

  /*

  function handleSupprimer() {
    let Supprimer = async () => {
      try {
        const responseOption = await axios.put(
          `/vehicleAnnonces/` + data?.vehiculeAnnonceId,
          { status: "2" },
        );
        if (responseOption.data) {
          toast.success("L'utilisateur a été bien rejeté avec succès!");
        }
      } catch (error) {
        console.error("Erreur lors de la requête Axios :", error);
      }
    };
    Supprimer();
  } */

  return (
    <>
      <ToastContainer />

      <div class="dashboard col-12">
        <div
          class="personal-data mb-4 bg-white shadow rounded-5 px-4 py-2 p-lg-4 aos animated aos-init aos-animate"
          data-aos="fade-up"
          data-aos-anchor-placement="top-bottom"
        >
          <div class="title">
            <p class="lead me-auto">Validation des données</p>

            <button onClick={handledesApprouver} class="btn btn-warning ms-2">
              Desapprouver
            </button>
            <button class="btn btn-lg ms-2 text-white" onClick={handleApprouver}>
              Approuver
            </button>
          </div>
          <div class="row">
            <div class="col-md-3 mb-3">
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setPermisConduire(PermisConduire == 1 ? 0 : 1);
                  }}
                >
                  Permis de conduire {PermisConduire == 1 && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>
              <figure class="figure userpicture">
                <button
                  className="btn btn-lg mt-3 text-white"
                  onClick={() => {
                    setPieceIdentite(PieceIdentite == 1 ? 0 : 1);
                  }}
                >
                  Pièce d'identité {PieceIdentite == 1 && <i class="bi bi-check2-square h3"></i>}
                </button>
              </figure>

              <div className="d-flex flex-column gap-2 mt-3">
                <button
                  className="btn btn-outline-primary"
                  data-bs-toggle="modal"
                  data-bs-target={`#VoirDocument-${data?.id}`}
                  onClick={() => {
                    setActiveDoc(PermisConduireDoc);
                    setActiveDocTitle('Permis de conduire');
                  }}
                >
                  Voir permis de conduire
                </button>

                <button
                  className="btn btn-outline-primary"
                  data-bs-toggle="modal"
                  data-bs-target={`#VoirDocument-${data?.id}`}
                  onClick={() => {
                    setActiveDoc(PieceIdentiteDoc);
                    setActiveDocTitle("Pièce d'identité");
                  }}
                >
                  Voir pièce d'identité
                </button>

                <button
                  className="btn btn-outline-primary"
                  data-bs-toggle="modal"
                  data-bs-target={`#VoirDocument-${data?.id}`}
                  onClick={() => {
                    setActiveDoc(ImmatriculationDoc);
                    setActiveDocTitle('Carte grise');
                  }}
                >
                  Voir carte grise
                </button>
              </div>

              <div
                className="modal fade"
                id={`VoirDocument-${data?.id}`}
                tabIndex="-1"
                aria-hidden="true"
              >
                <div className="modal-dialog modal-xl modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">{activeDocTitle}</h5>
                      <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                    </div>

                    <div className="modal-body">
                      {activeDoc ? (
                        <iframe
                          src={activeDoc}
                          width="100%"
                          height="600px"
                          title={activeDocTitle}
                          style={{ borderRadius: '12px' }}
                        />
                      ) : (
                        <p className="text-center text-muted">Aucun document disponible</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md mb-3">
              <div class="username mb-3">
                <label class="text-muted" for="username">
                  Nom complet
                </label>
                <input
                  id="username"
                  class="form-control"
                  type="text"
                  value={`${data?.firstName ? data?.firstName : ''} ${
                    data?.lastName ? data?.lastName : ''
                  }`}
                  disabled=""
                />
              </div>
              <div class="order mb-3">
                <label class="text-muted" for="id_order">
                  Addresse de location
                </label>
                <input
                  id="id_order"
                  class="form-control"
                  type="text"
                  value={`${data?.country ? data?.country : ''} ${data?.city ? data?.city : ''}`}
                  placeholder="Addresse de résidence"
                />
              </div>
              <div class="username mb-3">
                <label class="text-muted" for="username">
                  Email
                </label>
                <input
                  id="username"
                  class="form-control"
                  type="text"
                  value={`${data?.email}`}
                  disabled={true}
                />
              </div>
              <div class="content mb-3">
                <label class="text-muted" for="Content">
                  Immatriculation
                </label>
                <input
                  id="Immatriculation"
                  class="form-control"
                  type="text"
                  value={`${data?.immatriculation ? data?.immatriculation : ''}`}
                  placeholder="Immatriculation"
                />
              </div>
              <div class="reject mb-3">
                <label class="text-muted" for="Content">
                  Explication du rejet
                </label>
                <textarea
                  id="Content"
                  class="form-control autosize"
                  type="text"
                  value=""
                  rows="4"
                  style={{ height: '84px' }}
                ></textarea>
              </div>
              <button class="btn btn-lg ms-2 text-white" onClick={handleAskDocument}>
                Demander les documents requis
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminUserItem;
